module.exports = __webpack_public_path__ + "img/promo-7-mock.f96b29c2.png";